import type { CheckoutLineItem } from "../stores/basket";
import cfg from "../config/config";

import type { Cart } from "$lib/gql/gen/codegen";

export function getVoyadoContactId(name?: string) {
  name = "_vaI";
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

declare global {
  interface Window {
    va: any;
    redeal: any;
  }
}

function getVoyadoLocaleId(region: string, locale: string) {
  if (region === "row") return cfg.VOYADO_LOCALE_ROW;
  if (region === "uk") return cfg.VOYADO_LOCALE_UK;
  if (region === "us") return cfg.VOYADO_LOCALE_US;
  if (region === "de") {
    if (locale === "de") return cfg.VOYADO_LOCALE_DE_DE;
    if (locale === "en") return cfg.VOYADO_LOCALE_DE_EN;
  }
  if (region === "eu") {
    if (locale === "de") return cfg.VOYADO_LOCALE_EU_DE;
    if (locale === "en") return cfg.VOYADO_LOCALE_EU_EN;
    if (locale === "it") return cfg.VOYADO_LOCALE_EU_IT;
    if (locale === "fr") return cfg.VOYADO_LOCALE_EU_FR;
    if (locale === "es") return cfg.VOYADO_LOCALE_EU_ES;
  }
  if (region === "staging") return cfg.VOYADO_LOCALE_ROW;
}

export function voyadoSetCustomer(contactId: string) {
  if (window.va && typeof window.va !== "undefined") {
    window.va("setContactId", contactId);
  }
}

export async function voyadoIdentifyCustomer(email: string) {
  try {
    const identifyCustomerRequest = await fetch(
      `${cfg.BASE_PATH || ""}/api/voyado?email=${email}`,
    );

    const response = await identifyCustomerRequest.json();

    const contactId = response.contactId;

    if (contactId) voyadoSetCustomer(contactId);
  } catch (error) {
    console.log("Voyado customer not set ", error);
  }
}

export async function voyadoViewProduct(
  categoryName: string,
  sku: string,
  region: string,
  locale: string,
) {
  if (
    typeof window !== "undefined" &&
    window.va &&
    typeof window.va !== "undefined"
  ) {
    const contactId = getVoyadoContactId();

    window.va("productview", {
      categoryName: categoryName,
      ...(contactId && { contactId: contactId }),
      itemId: sku,
      locale: getVoyadoLocaleId(region, locale),
    });
  }
}

export async function voyadoUpdateCart(
  cart: Cart,
  region: string,
  locale: string,
) {
  if (
    typeof window !== "undefined" &&
    window.va &&
    typeof window.va !== "undefined"
  ) {
    const cartUrl = cart.checkoutUrl;
    const cartRef = cart.id;
    const items = cart.lines.edges.map(edge => {
      return {
        itemId: edge.node.merchandise.sku,
        quantity: edge.node.quantity,
      };
    });

    const contactId = getVoyadoContactId();
    window.va("cart", {
      cartRef,
      ...(contactId && { contactId: contactId }),
      cartUrl,
      locale: getVoyadoLocaleId(region, locale),
      items,
    });
  }
}
